import { useContainerStyle } from '../hooks';
import PromotionMessage from '../promotionMessage'
import Waitings from '../waitings'
import MenuPage from '../menu/MenuPage';

const BG_WIDTH = 3835;
const BG_HEIGHT = 2133;

function Landscape (props) {
    const { screenWidth, screenHeight, landscapeFlag, storeId, matchMenu } = props;
    const clsName = (screenWidth / screenHeight) < (BG_WIDTH / BG_HEIGHT) ? 'full-width' : 'full-height';
    const style = useContainerStyle({
        screenWidth,
        screenHeight,
        BG_WIDTH,
        BG_HEIGHT
    });
    const menuCls = matchMenu ? 'menu' : '';

    return (
        <div className={`landscape ${clsName} ${menuCls}`} style={style}>
            {matchMenu ? (
                <MenuPage storeId={storeId} landscapeFlag={landscapeFlag} />
            ) : (
                <>
                    <div className="blue-circle" />
                    <Waitings storeId={storeId} landscapeFlag={landscapeFlag} />
                    <PromotionMessage storeId={storeId} />
                </>
            )}
        </div>
    );
}

export default Landscape
